import './RejectionComment.scss';

import { FC } from 'react';
import moment from 'moment';
import { Card, Col, Row } from 'react-bootstrap';

import { DocumentComment } from '../../../models/DocumentComment';

interface RejectionCommentProps {
  rejectionComment: DocumentComment;
}

const RejectionComment: FC<RejectionCommentProps> = ({ rejectionComment }) => (
  <Card className="comment">
    <Card.Body>
      <Row>
        <Col md={2} xs={2} className="gx-1">
          <div
            className="user-photo"
            style={{
              display: rejectionComment.userPicture ? 'block' : 'none',
            }}
          >
            <img
              src={rejectionComment.userPicture}
              alt={rejectionComment.userId}
              className="img-fluid"
            />
          </div>
        </Col>
        <Col className="gx-2">
          <h5
            className="user-handle"
            style={{ display: rejectionComment.userName ? 'block' : 'none' }}
          >
            {rejectionComment.userName}
          </h5>
          <div className="details">{rejectionComment.comments}</div>
          <div className="date-occurred">
            Shared on
            {' '}
            {moment(new Date(rejectionComment.dateRejected)).format(
              'MM/DD/YYYY',
            )}
          </div>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default RejectionComment;
